import React, { Component } from "react";

import $ from 'jquery'
import { valueConverter_2 } from '../../../util-functions/util-funtions'
import RegionalPieChart from '../../../components/pie-charts/regionalPieChart';

const Data = [
  { week: 1, actual: 12, baseline: 123, activatesale: 234 },
  { week: 2, actual: 23, baseline: 345, activatesale: 67 },
  { week: 3, actual: 4, baseline: 345, activatesale: 123 },
  { week: 4, actual: 23, baseline: 34, activatesale: 789 },
  { week: 5, actual: 45, baseline: 234, activatesale: 123 },
  { week: 6, actual: 123, baseline: 3789, activatesale: 789 },
  { week: 7, actual: 34, baseline: 23, activatesale: 34 },
  { week: 8, actual: 34, baseline: 23, activatesale: 34 },
  { week: 6, actual: 123, baseline: 3789, activatesale: 789 },
  { week: 7, actual: 34, baseline: 23, activatesale: 34 },
  { week: 8, actual: 34, baseline: 23, activatesale: 34 },
  { week: 8, actual: 34, baseline: 23, activatesale: 34 }
];

class FD_table extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    $(document).ready(function () {
      var height = Math.max($("#leftdiv").height(), $("#rightdiv").height());
      $("#leftdiv").height(height);
      $("#rightdiv").height(height);
    });
    $(document).ready(function () {
      var height = Math.max($("#leftdiv1").height(), $("#rightdiv1").height());
      $("#leftdiv1").height(height + 1);
      $("#rightdiv1").height(height);
    });
    $(document).ready(function () {
      var height = Math.max($("#leftdiv2").height(), $("#rightdiv2").height());
      $("#leftdiv2").height(height + 1);
      $("#rightdiv2").height(height);
    });

    let newMyObject = []
    Object.entries(this.props.data).forEach((item, ind) => {
      if (item[0] === "Forecast" || item[0] === "TopThreeDD" || Object.values(item[1]).length === 0 || item[0] === 'IncrementalSales' || item[0] === "Secondary" || item[0] === 'TotalDemand' ) {

      } else {
        if (ind === 3) {
          newMyObject.push(['IncrementalSales', {}])
        }
        newMyObject.push(item)
      }
    })

    if (this.props.weekly) {
      return (
        <div className='fd-two-tables-container'>
          <div className='fd-two-tables'>
            <div className='table-container' style={{overflowX:'hidden'}}>
              <table style={{
                borderCollapse: 'collapse',
                backgroundColor: '#ffffff', tableLayout: 'fixed', padding: '10px',
                paddingRight: '0px', textAlign: 'left'
              }}>

                <tr style={{ backgroundColor: '#0353a4', fontSize: '12px' }}>
                  <th style={{ color: '#ffffff', textAlign: 'center', height: '24px' }}>Number of Weeks</th>
                </tr>

                <tbody style={{ fontSize: '12px' }}>
                  {newMyObject.map(([key, value],ind) => <tr key={ind} id={key === 'TopThreeDD' ? 'leftdiv' : key === 'ActiveSchemes' ? 'leftdiv1' : key === 'RegionalCut' ? 'leftdiv2' : null}>
                    <td style={{ fontWeight: 'bold', width: '12vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7', color: '#0353a4' }}>{key === 'Forecast' ? void 0 : key}</td>
                  </tr>)}
                </tbody>

              </table>
            </div>

            <div className='table-container' style={{
              width: '85%', padding: '12px', paddingLeft: '0px'
            }} id='div13'>
              <table style={{ tableLayout: 'fixed', width: '650%', padding: '12px', borderCollapse: 'collapse', textAlign: 'left' }}>
                <tr style={{ backgroundColor: '#0353a4', fontSize: '12px' }}>
                  {this.props.weekNo.map((item, index) => (
                    <th style={{ color: '#ffffff', textAlign: 'center', height: '24px', border: '1px solid #e6e6e7' }} key={index}>
                      week {item}
                    </th>
                  ))}
                </tr>

                <tbody style={{ fontSize: '12px' }}>

                  <tr>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.Actuals).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.Baseline).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.IncrementalSales).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.ActivatedSales).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(3)) : 0}</td>) : null}
                  </tr>

                  <tr id='rightdiv' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.TopThreeDD).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', padding: '12px', border: '1px solid #e6e6e7' }}>{value.map((item,ind) => <tr key={ind}><td >{item}</td></tr>)}</td>) : null}
                  </tr>

                  <tr id='rightdiv1' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.ActiveSchemes).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', padding: '12px', border: '1px solid #e6e6e7' }}>{value.map((item,ind) => <tr key={ind}><td >{item}</td></tr>)}</td>) : null}
                  </tr>

                  <tr id='rightdiv2' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.RegionalCut).map(([key, value],ind) => <td key={ind} style={{ border: '1px solid #e6e6e7' }}>
                      <span className='pie-cell'><RegionalPieChart data={value} /></span></td>
                    ) : null}
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div className='fd-pie-chart-legend-container'>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#4B9795' }}></span>
              <span>Khi</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#E3575A' }}></span>
              <span>Lhr</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#B27AA1' }}></span>
              <span>Isl</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#6A8299' }}></span>
              <span>Mul</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#68BE5D' }}></span>
              <span>Fsd</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#EBD165' }}></span>
              <span>Psh</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#FE9F4C' }}></span>
              <span>Hyd</span>
            </div>
          </div>

        </div>
      )
    } else {
      return (
        <div className='fd-two-tables-container'>
          <div className='fd-two-tables'>
            <div className='table-container'  style={{overflowX:'hidden'}}>
              <table style={{
                borderCollapse: 'collapse',
                backgroundColor: '#ffffff', tableLayout: 'fixed', padding: '10px',
                paddingRight: '0px', textAlign: 'left'
              }}>

                <tr style={{ backgroundColor: '#0353a4', fontSize: '12px' }}>
                  <th style={{ color: '#ffffff', textAlign: 'center', height: '24px' }}>Number of Months</th>
                </tr>

                <tbody style={{ fontSize: '12px' }}>
                  {newMyObject.map(([key, value],ind) => <tr key={ind} id={key === 'TopThreeDD' ? 'leftdiv' : key === 'ActiveSchemes' ? 'leftdiv1' : key === 'RegionalCut' ? 'leftdiv2' : null}>
                    <td style={{ fontWeight: 'bold', width: '12vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7', color: '#0353a4' }}>{key === 'Forecast' ? void 0 : key}</td>
                  </tr>)}
                </tbody>

              </table>
            </div>

            <div className='table-container' style={{
              width: '88.5%', padding: '12px', paddingLeft: '0px'
            }} id='div13'>
              <table style={{ tableLayout: 'fixed', width: '201%', padding: '12px', borderCollapse: 'collapse', textAlign: 'left' }}>
                <tr style={{ backgroundColor: '#0353a4', fontSize: '12px' }}>
                  {Data.map((item, index) => (
                    <th style={{ color: '#ffffff', textAlign: 'center', height: '24px', border: '1px solid #e6e6e7' }} key={index}>
                      Mon {index + 1}
                    </th>
                  ))}
                </tr>

                <tbody style={{ fontSize: '12px' }}>

                  <tr>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.Actuals).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.Baseline).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.IncrementalSales).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(2)) : 0}</td>) : null}
                  </tr>

                  <tr style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.ActivatedSales).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', paddingLeft: '12px', height: '24px', border: '1px solid #e6e6e7' }}>{value ? valueConverter_2(value.toFixed(3)) : 0}</td>) : null}
                  </tr>

                  <tr id='rightdiv' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.TopThreeDD).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', padding: '12px', border: '1px solid #e6e6e7' }}>{value.map((item,ind) => <tr key={ind}><td >{item}</td></tr>)}</td>) : null}
                  </tr>

                  <tr id='rightdiv1' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.ActiveSchemes).map(([key, value],ind) => <td key={ind} style={{ width: '13vw', padding: '12px', border: '1px solid #e6e6e7' }}>{value.map((item,ind) => <tr key={ind}><td >{item}</td></tr>)}</td>) : null}
                  </tr>

                  <tr id='rightdiv2' style={{ borderBottom: '1px solid lightgrey' }}>
                    {Object.entries(this.props.data).length > 1 ? Object.entries(this.props.data.RegionalCut).map(([key, value],ind) => <td key={ind} style={{ border: '1px solid #e6e6e7' }}>
                      <span className='pie-cell'><RegionalPieChart data={value} /></span></td>
                    ) : null}
                  </tr>

                </tbody>
              </table>
            </div>
          </div>
          <div className='fd-pie-chart-legend-container'>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#4B9795' }}></span>
              <span>Khi</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#E3575A' }}></span>
              <span>Lhr</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#B27AA1' }}></span>
              <span>Isl</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#6A8299' }}></span>
              <span>Mul</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#68BE5D' }}></span>
              <span>Fsd</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#EBD165' }}></span>
              <span>Psh</span>
            </div>
            <div className='legend-item'>
              <span className='legend-shape' style={{ backgroundColor: '#FE9F4C' }}></span>
              <span>Hyd</span>
            </div>
          </div>
        </div>
      )
    }
  }
}
export default FD_table;
